import axios from 'axios';
import {QUIKLEARN_BACKEND_URL} from 'config/app.config';
import {getWebAccessToken} from 'utils/webAuthSession';

/**
 * The same billing endpoints the portal uses, with the learner's web session. Every price and every
 * grant is the server's (Sol build-plan D3/D4); this only asks and redirects.
 */
const api = async (method, path, data) => {
  const token = getWebAccessToken();
  if (!token) throw new Error('Your web learning session has expired. Please reopen the course.');
  const response = await axios({
    method,
    url: `${String(QUIKLEARN_BACKEND_URL).replace(/\/$/, '')}${path}`,
    data,
    headers: {'Content-Type': 'application/json', Authorization: `Bearer ${token}`},
  });
  return response.data;
};

export const getProfile = async () => (await api('get', '/api/user'))?.data;
export const getPlans = async () => {
  const body = await api('get', '/api/user/plans');
  return {plans: body?.data || [], catalog: body?.catalog || null};
};
export const getUsage = async () => (await api('get', '/api/user/usage'))?.data;
export const quoteOffer = async (offerId, catalog) =>
  (await api('post', `/api/user/billing-offers/${encodeURIComponent(offerId)}/quote`, {catalog}))?.data;
export const checkoutUrl = async (planId, offerSnapshotId, returnTo) =>
  (await api('post', '/api/create-checkout-session', {planId, offerSnapshotId, returnTo}))?.data?.url;
export const previewChange = async offerId => (await api('post', '/api/user/subscription/change-plan/preview', {offerId}))?.data;
export const changePlan = async (offerId, quote) => (await api('post', '/api/user/subscription/change-plan', {offerId, quote}))?.data;
export const topUpCheckout = async (basket, returnTo) => (await api('post', '/api/user/topups/checkout', {...basket, returnTo}))?.data;
export const checkoutState = async sessionId =>
  (await api('get', `/api/user/checkout-sessions/${encodeURIComponent(sessionId)}`))?.data;
export const topUpStatus = async purchaseId => (await api('get', `/api/user/topups/${encodeURIComponent(purchaseId)}`))?.data;

/** What goes back with the confirmation, so the charge is exactly the quote (Sol owner-retest-b C2). */
export const confirmedQuote = preview =>
  preview?.chargeNow && preview.prorationDate
    ? {prorationDate: preview.prorationDate, amountDueMinor: preview.amountDueMinor, currency: preview.currency, cardLast4: preview.card?.last4 ?? null}
    : undefined;

/** This world and unit, without an earlier checkout result - where Stripe brings the learner back. */
export const returnHere = () => {
  const url = new URL(window.location.href);
  ['checkout', 'topup', 'purchase', 'session_id'].forEach(key => url.searchParams.delete(key));
  url.hash = '';
  return url.toString();
};

/** Leave for Stripe from the top window (the player may be framed). */
export const goTo = url => {
  try {
    window.top.location.assign(url);
  } catch (_) {
    window.location.assign(url);
  }
};
